/**
 * Rounding via scaling means that based on the precision the number of places
 * will be converted to a whole number and then brought back to decimal form by
 * dividing by the same factor of scaling. This avoids JS's floating point
 * inaccuracies as much as possible.
 * @param {Number} n
 */
const roundToTwoDecimals = (n) => {
  const precision = 100; // 100 -> .00
  return Math.round((n + Number.EPSILON) * precision) / precision;
};

export default roundToTwoDecimals;